import tinycolor from 'tinycolor2';

export function applyBrandingToTheme({
  injectedTheme,
  themeVersion,
  brandColor,
}: {
  injectedTheme: any;
  themeVersion: string;
  brandColor: string | undefined;
}) {
  // const theme =
  //   themeVersion === 'light' ? injectedTheme.Light : injectedTheme.Dark;
  const theme = themeVersion === 'dark' ? injectedTheme.Dark : injectedTheme.Light;

  if (!brandColor) return theme;

  return {
    ...theme,
    Color: {
      ...theme.Color,
      Brand: {
        ...theme.Color.Brand,
        Lightest: tinycolor.mix('#FFFFFF', brandColor, 7).toHexString(),
        Light: tinycolor.mix('#FFFFFF', brandColor, 10).toHexString(),
        Primary: brandColor,
        Dark: tinycolor(brandColor).darken(10).toHexString(),
      },
    },
  };
}
